import React from 'react';
export function TopBar() {
  return <div className="sticky top-0 z-40 flex min-h-[38px] w-full items-center justify-center bg-chem px-4 py-2 text-center" data-id="element-316" data-mp="3sdwyhb040hms">
      <p className="text-[11px] font-medium leading-snug text-white sm:text-xs" data-id="element-317" data-mp="234ztup32nk7a">
        <span className="sm:hidden" data-id="element-318" data-mp="1y42gqqwx5gcn">🌍 Dostęp od razu • Materiały cyfrowe do pobrania</span>
        <span className="hidden sm:inline" data-id="element-319" data-mp="1t6aep42k8duq">
          🌍 Dostęp od razu • Materiały cyfrowe do pobrania • Dla nauczycieli chemii w Polsce
        </span>
      </p>
    </div>;
}